__turbopack_context__.v({
  "className": "brownstdfont_df2282c5-module__3ZKsxa__className",
  "variable": "brownstdfont_df2282c5-module__3ZKsxa__variable",
});
